/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ServiceEngineGroupModule
 */

import { Injector } from '@angular/core';
import { SE_GROUP_COLLECTION_TOKEN } from 'ajs/modules/service-engine-group/se-group.tokens';

import { SEGroupCollection }
    from 'ajs/modules/service-engine-group/factories/se-group.collection.factory';

const $injector = '$injector';

export const seGroupCollectionProvider = {
    deps: [$injector],
    provide: SEGroupCollection,
    useFactory(injector: Injector): typeof SEGroupCollection {
        return injector.get(SE_GROUP_COLLECTION_TOKEN);
    },
};
